import { Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { getUnauthorizedComponent } from "component/dashboard/slidelist_utils";
import { aclPermissions, hasPermissions } from "const/ACLPermissions";
import { Heading } from "../component/dashboard/components";
import { LoadingText } from "../component/gammaviewer/components/components";
import DisksApp from "../component/gammaviewer/sidebarTop_apps/DisksApp";
import { post } from "../helper/request";

class Disks extends DisksApp {


	updateDiskLabel = (id, label) => {
		console.log(id, label)
		post(`/api/disks/edit_label/`, {
			id,
			label
		})
	}

	render() {
		if (!this.state.disks)
			return <LoadingText/>

		if (this.state.disks.length === 0)
			return <Typography> No disks found </Typography>

		if (!hasPermissions([aclPermissions.disk_info_menu])) {
			return getUnauthorizedComponent()
		}

		return (
			<>
				<Heading>Disks</Heading>
				<DataGrid
					sx={{paddingX: 5}}
					rows={this.state.disks}
					columnVisibilityModel={{
						id: false,
					}}
					onCellEditStop={(params, event) => {
						console.log(params, event);
						this.updateDiskLabel(params.id, event.target.value)
					}}
					columns={Object.keys(this.state.disks[0]).map((key) => {
						let editable = false
						if (key==="Label (Editable)"){
							editable = true
						}
						return {
							field: key,
							headerName: key,
							flex: 1,
							editable: editable
						}
					})}
				/>
			</>
		);

	}
}

export default Disks;
